import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import bannerImage from "../../../assets/user/images/banner-card.png";
import { useTranslation } from "react-i18next";
import {
  TrimText,
  formateDateWithMonth,
  getSessionKey,
  removeSessionKey,
  setSessionKey,
} from "../../../utils/commonfunction";
import CustomPagination from "../../admin/common/custompagination";
import { RoomList } from "../services/room.services";
import { useSelector } from "react-redux";
import FrontLoader from "../../globalComponents/FrontLoader";
import moment from "moment";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../utils/Constants";

const SISUserRooms = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [rooms, setRooms] = useState([]);
  const [itemperpage] = useState(6);
  const [page, setPage] = useState(1);
  const [datalength, setDataLength] = useState("");
  const { t } = useTranslation();
  const [globalsearch, setGlobalSearch] = useState("");
  const [dateFilterValue, setDateFilterValue] = useState();
  const [search, setSearch] = useState({});
  const ChooseDateTrigger = useRef();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [loader,setLoader] = useState(true);

  let reducerData = useSelector(state => state.manageLmBackOffice);

  useEffect(() => {
    document.addEventListener("updateActivityHeight", (e) => {
      let id = e.detail.id;
      let height = e.detail.height;
      let index = e.detail.index;
      if (!getSessionKey(id) || getSessionKey(id) !== height) {
        setSessionKey(id, height);
        let element = document.getElementById(
          "showMoreContainerbutton" + index
        );
        if (element) {
          removeSessionKey(id);
          if (height > 100) {
            element.classList.remove("d-none");
          }
        }
      }
    });
    return () => {
      for (let i = 0; i <= 20; i++) {
        removeSessionKey("showMoreContainer" + i);
      }
    };
  }, []);

  useEffect(() => {
    setLoader(true);
    const formData = new FormData();
    formData.append("page", params.pgno);
    formData.append("per_page", itemperpage);
    formData.append("global_search", globalsearch);
    formData.append("search", JSON.stringify(search));
    formData.append("event_id", reducerData);
    RoomList(formData)
      .then((response) => {
        if(response?.success){
          setRooms(
            response && response.data && response.data.list
              ? response.data.list
              : []
          );
          setDataLength(response?.data?.total_records);
          setPage(
            response && response?.data && response?.data?.page
              ? response?.data?.page
              : 1
          );
          setLoader(false);
        }
        else{
          Swal.fire({
            icon: "error",
            text: response.message,
            ...SWAL_SETTINGS,
            timer: 4000
        });
        setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [itemperpage, params.pgno, globalsearch, search,reducerData]);

  const handleShowMore = (e, id) => {
    if (e.target.classList.contains("active")) {
      e.target.classList.remove("active");
      document.getElementById(id).classList.add("max-100");
      e.target.innerText = "Show More";
    } else {
      e.target.classList.add("active");
      document.getElementById(id).classList.remove("max-100");
      e.target.innerText = "Show Less";
    }
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setDateFilterValue("");
    setSearch({});
  };
  
  const handleClick = () => {
    ChooseDateTrigger.current.click();
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (fromDate && toDate) {
      sr[key] = {
        start: `${fromDate}`,
        end: `${toDate}`
      };
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const handleCloseModal = () => {
    const closeButton = document.getElementById('close_button');
    closeButton.click();
    setFromDate('');
    setToDate('');
  };
  
  const handleDateChange = (e, type) => {
    const value = e.target.value;
    if (type === 'from') {
      setFromDate(value);
    } else if (type === 'to') {
      setToDate(value);
    }
  };

  const handleOkButtonClick = () => {
    handleCloseModal(); 
    if (fromDate && toDate) {
      prepareSearch('event_date', [moment(fromDate).startOf('day'), moment(toDate).endOf('day')]);
    } else {
      setSearch({});
    }
  };
  
  const isOkButtonDisabled = !(fromDate && toDate);

  const formattedDateRange = search.event_date ? `${moment(search.event_date.start).format('YYYY-MM-DD')} to ${moment(search.event_date.end).format('YYYY-MM-DD')}` : '';


  return (
    <>
      <div className="wraper-inner cpt bg-grey">
        <section className="banner-card mt-4">
          <div className="container">
            <div
              className="banner-card-content text-center"
              style={{ backgroundImage: `url(${bannerImage})` }}
            >
              <h1>{t('web_sis_user_rooms')}</h1>
              <nav className="breadcrumb text-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/sis-user/home`}>{t("web_header_heading_home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t('web_sis_user_rooms')}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>
        <section className="forums-listing grid-box-main mt-5 pb-5">
          <div className="container">
            <div className="user-box-head d-flex justify-content-between mb-4">
              <h3 className="inner-title mb-0"></h3>
              <div className="user-right filter-responsive d-flex align-items-center">
                <div className="search-box ms-1">
                  <input
                    type="text"
                    name=""
                    className="form-control rounded-3"
                    placeholder={t('web_lbl_search')}
                    value={globalsearch}
                    onChange={(e) => {
                      setGlobalSearch(e.target.value);
                    }}
                  />
                  <button className="btn-search">
                    <i className="ti ti-search"></i>
                  </button>
                </div>
                 <div className="form-group ms-1 cp">
                  <input
                    className="form-control cpl rounded-3 h-45px"
                    type="text"
                    onClick={() => handleClick()}
                    value={formattedDateRange}
                    placeholder={t('web_lbl_from_to')}
                    style={{ width: "200px" }}
                  ></input>
                </div>
                <button
                  className="btn btn-warning ms-1"
                  onClick={(e) => {
                    resetFilter(e);
                  }}
                >
                  {t("web_lbl_reset_filter")}
                </button>
              </div>
            </div>
            <div className="row mt-2">
            {loader ? 
              <FrontLoader/>
                :
               <>
              {rooms && rooms?.length > 0
                ? rooms.map((data, i) => {
                    return (
                      <div className="col-md-4" key={i}>
                        <div className="grid_back h-100">
                          <div className="grid-box d-flex flex-column justify-content-between align-items-start">
                            <div className="w-100">
                                <h3 className="text-capitalize">
                                  {data?.name ? TrimText(data?.name) : null}
                                </h3>
                              <div className="d-flex justify-content-center mb-4">
                                <div className="d-flex justify-content-center align-items-center w-100" style={{backgroundColor: "var(--light_active_color)"}}>
                                  <i className="ri-home-7-line" style={{fontSize:"8em", color:"var(--primary_active_color)"}}></i>
                                </div>
                              </div>
                              <div className="date-info">
                                <i className="ri-calendar-event-line"></i>
                                {formateDateWithMonth(data?.start_date) +
                                  " - " +
                                  formateDateWithMonth(data?.end_date)}
                              </div>
                              <div
                                className="surveyPage max-100"
                                id={"showMoreContainer" + i}
                                ref={(el) => {
                                  if (el) {
                                    const evt = new CustomEvent(
                                      "updateActivityHeight",
                                      {
                                        detail: {
                                          id: "showMoreContainer" + i,
                                          index: i,
                                          height: el.scrollHeight,
                                        },
                                      }
                                    );
                                    document.dispatchEvent(evt);
                                  }
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: data?.description,
                                }}
                              ></div>
                              {/* Show more integration */}
                              <div
                                className="d-flex justify-content-end w-100 d-none mt-2"
                                id={"showMoreContainerbutton" + i}
                              >
                                <button
                                  type="button"
                                  className="show-more"
                                  onClick={(e) => {
                                    handleShowMore(e, "showMoreContainer" + i);
                                  }}
                                >
                                  Show More
                                </button>
                              </div>
                            </div>
                            <button
                              className="btn btn-primary mt-2"
                              onClick={() =>
                                navigate(`/sis-user/rooms/book/${data?._id}`)
                              }
                            >
                              {t('web_sis_user_book')}
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : 
                <h2 style={{ textAlign: "center", fontSize: "25px" }}>
							{t('web_lbl_no_records')}
						</h2>
                }
                </>
              }
            </div>
          </div>
          <div id="div_class">
            {datalength && datalength > 0 ? (
              <div className="mt-4 text-right pagination-main d-flex justify-content-end  pe-4">
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={page}
                  setPage={setPage}
                  pageRoute={[
                    { name: "Rooms", path: "/sis-user/rooms/list" },
                  ]}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </section>
      </div>
    <a className="d-none" ref={ChooseDateTrigger} data-bs-toggle="modal" href="#ChoosePayment" role="button"><span></span></a>
      <div className="modal fade" id="ChoosePayment" aria-hidden="true" data-bs-backdrop="static" aria-labelledby="ChoosePaymentLabel" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <span className="announcements-title" id="ChoosePaymentLabel">{t('web_sis_user_select_date')}</span>
              <button type="button" className="btn-close" id="close_button" data-bs-dismiss="modal" aria-label="Close" onClick={()=>{handleCloseModal()}}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <div className="row">
                  <div className="col">
                    <label htmlFor="fromDate" className="form-label">{t('web_sis_user_from')}:</label>
                    <input
                      id="fromDate"
                      className="form-control"
                      type="date"
                      value={fromDate}
                      onChange={(e) => handleDateChange(e, 'from')}
                      style={{ width: "100%" }}
                      onClick={(e) => {e.target.showPicker(); }}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="toDate" className="form-label">{t('web_sis_user_to')}:</label>
                    <input
                      id="toDate"
                      className="form-control"
                      type="date"
                      value={toDate}
                      onChange={(e) => handleDateChange(e, 'to')}
                      style={{ width: "100%" }}
                      onClick={(e) => {e.target.showPicker(); }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" disabled={isOkButtonDisabled} onClick={handleOkButtonClick}>OK</button>
              <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Cancel</button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default SISUserRooms;
